import {
  DateRangePreset,
  dateRangePresetsToComparisonPeriodMap,
} from '../../constants/dateRangePreset';

export const getComparisonPeriodForPreset = (dateRangePreset: DateRangePreset): string =>
  dateRangePresetsToComparisonPeriodMap[dateRangePreset] ?? dateRangePreset;
